module.exports = __webpack_public_path__ + "static/favicon-9222d2275901040eaafe07dfea5c2d3c.ico";